module.exports = __webpack_public_path__ + "assets/img/39f9-lt.svg";